module.exports = __webpack_public_path__ + "img/ninja-8-bit.09ba4d82.jpg";